<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('grant_budget_management.budget_allocation') }}</h4>
          </template>

          <template v-slot:headerAction>
              <router-link to="/grant-allowance-service/budget-management/budget-allocation-add">
                    <b-button variant="primary">
                    {{  $t('globalTrans.add_new') }}
                    </b-button>
              </router-link>
          </template>

          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(amount)="data">
                      <span>{{ $n(data.item.amount) }}</span>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span class="badge badge-danger" v-if="data.item.status == 1">{{$t('globalTrans.pending')}}</span>
                      <span class="badge badge-success" v-else>{{$t('grant_budget_management.allocated')}}</span>
                    </template>

                    <!-- Action -->
                    <template v-slot:cell(action)="data">
                      <!-- <b-button variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit">
                        <router-link :to="{ path: '/grant-allowance-service/budget-management/budget-allocation-add', query: { id: data.item.id }}"
                          class="iq-bg-success mr-1 mb-1" size="sm">
                          <i class="ri-ball-pen-fill m-0"></i>
                        </router-link>
                      </b-button>

                     <b-button title="View Details" v-b-modal.modal-1 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>

                      <b-button title="Change Status" :variant="data.item.status === 0 ? ' iq-bg-danger' : ' iq-bg-success'" size="sm" @click="allocated(data.item)">
                        <i class="fas" :class="data.item.status === 1 ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                      </b-button> -->
                      <router-link :to="{ path: '/grant-allowance-service/budget-management/budget-allocation-add', query: { id: data.item.id }}"
                          class="btn_table_action btn_blue"><i class="ri-ball-pen-fill m-0"></i>
                      </router-link>
                     <a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-1 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                      <a href="javascript:" class="btn_table_action btn_rad" title="status" v-if="data.item.status === 0" @click="allocated(data.item)"> <i class="fas fa-toggle-off"></i></a>
                      <a href="javascript:" class="btn_table_action btn_blue" title="status" v-else @click="allocated(data.item)"> <i class="fas fa-toggle-on"></i></a>

                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-1" size="lg" :title="$t('grant_budget_management.budget_allocation_details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId"/>
    </b-modal>

  </b-container>
</template>
<script>
import Details from './Details'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { budgetAllocationListApi, budgetAllocationToggleStatusApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import moment from 'moment'

export default {
    mixins: [RouteBasedList],
    components: {
        Details
    },
    data () {
      return {
        search: {
          org_id: 0,
          fiscal_year_id: 0
        },
        item: null,
        rows: []
      }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
                { label: this.$t('user_role.organization'), class: 'text-center' },
                { label: this.$t('grant_budget_management.fiscal_year'), class: 'text-center' },
                { label: this.$t('globalTrans.district'), class: 'text-center' },
                { label: this.$t('globalTrans.upazila'), class: 'text-center' },
                { label: this.$t('grant_budget_management.amount'), class: 'text-center' },
                { label: this.$t('globalTrans.registration_time'), class: 'text-center' },
                { label: this.$t('globalTrans.status'), class: 'text-center' },
                { label: this.$t('globalTrans.action'), class: 'text-center w-15' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                  { key: 'index' },
                  { key: 'org_bn' },
                  { key: 'fiscal_year_bn' },
                  { key: 'district_bn' },
                  { key: 'upazila_bn' },
                  { key: 'amount' },
                  { key: 'created_at' },
                  { key: 'status' },
                  { key: 'action' }
                ]
            } else {
                keys = [
                  { key: 'index' },
                  { key: 'org_en' },
                  { key: 'fiscal_year_en' },
                  { key: 'district_en' },
                  { key: 'upazila_en' },
                  { key: 'amount' },
                  { key: 'created_at' },
                  { key: 'status' },
                  { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        },
        organizationList () {
          return this.$store.state.orgList.filter(item => item.status === 0)
        },
        fiscalYearList: function () {
          return this.$store.state.commonObj.fiscalYearList
        }
    },
    watch: {
    },
    created () {
        this.loadData()
    },
    mounted () {
    },
    methods: {
        searchData () {
        //   this.loadData()
        },
        allocated (item) {
          var message = this.$t('grant_budget_management.change_status')
          this.confirmationPopup(message, function (response) {
            if (response === true) {
              RestApi.deleteData(grantAllowanceServiceBaseUrl, `${budgetAllocationToggleStatusApi}/${item.id}`).then((res) => {
                if (res.success) {
                  // var msg = 'Allocated Successfull'
                  // this.successNotification(msg)
                }
              })
            }
          })
          this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: true })
        },
        view (item) {
          this.editItemId = item.id
        },
        edit (item) {
          this.editItemId = item.id
          this.item = item
          this.$router.push({ path: '/grant-allowance-service/budget-management/budget-preparation-add', query: { item: item } })
        },
        loadData () {
          const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
          RestApi.getData(grantAllowanceServiceBaseUrl, budgetAllocationListApi, params).then(response => {
              if (response.success) {
                  this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                  this.paginationData(response.data)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
        },
        getRelationalData (data) {
          const listData = data.map(item => {
            const org = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
            const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
            const districtObj = this.$store.state.commonObj.districtList.find(data => data.value === item.district_id)
            const upazilaObj = this.$store.state.commonObj.upazilaList.find(data => data.value === item.upazilla_id)
            const tmpCreatedTime = moment(item.created_at).startOf('minute').fromNow()

           const evaluationData = {
              org_bn: org !== undefined ? org.text_bn : '',
              org_en: org !== undefined ? org.text_en : '',
              fiscal_year_bn: fiscalYear !== undefined ? fiscalYear.text_bn : '',
              fiscal_year_en: fiscalYear !== undefined ? fiscalYear.text_en : '',
              district_en: districtObj !== undefined ? districtObj.text_en : '',
              district_bn: districtObj !== undefined ? districtObj.text_bn : '',
              upazila_en: upazilaObj !== undefined ? upazilaObj.text_en : '',
              upazila_bn: upazilaObj !== undefined ? upazilaObj.text_bn : '',
              created_at: tmpCreatedTime !== undefined ? tmpCreatedTime : ''
            }

            // Assign
            return Object.assign({}, item, evaluationData)
          })
          return listData
        }
    }
}
</script>
